export default __webpack_public_path__ + "static/media/card-shadow-none@2x.dcc04456.png";